export function displayLocaleTitle(playlist, localeParam) {
  const locale = (localeParam || this.$i18n.locale).toLowerCase()
  if (playlist && playlist['official_playlist'] && playlist['official_playlist_id']) {
    const langsAry = playlist['official_playlist'].langs
    let matchedLangObj = langsAry.find(item => item.locale.toLowerCase() === locale)
    if (!matchedLangObj && locale !== 'en-us') {
      matchedLangObj = langsAry.find(item => item.locale.toLowerCase() === 'en-us')
    }
    if (!matchedLangObj && langsAry.length > 0) {
      matchedLangObj = langsAry[0]
    }
    if (!matchedLangObj && langsAry.length === 0 && playlist.title) {
      return playlist.title
    }
    return (matchedLangObj && matchedLangObj.title) || ''
  }
  return (playlist && playlist.title) || ''
}
export function displayLocaleDescription(playlist, localeParam) {
  const locale = (localeParam || this.$i18n.locale).toLowerCase()
  if (playlist && playlist['official_playlist'] && playlist['official_playlist_id']) {
    const langsAry = playlist['official_playlist'].langs
    let matchedLangObj = langsAry.find(item => item.locale.toLowerCase() === locale)
    if (!matchedLangObj && locale !== 'en-us') {
      matchedLangObj = langsAry.find(item => item.locale.toLowerCase() === 'en-us')
    }
    if (!matchedLangObj && langsAry.length > 0) {
      matchedLangObj = langsAry[0]
    }
    return (matchedLangObj && matchedLangObj.description) || ''
  }
  return (playlist && playlist.description) || ''
}
// Deprecated ?
// export function displayLocaleScenarioTitle(playlist, localeParam) {
//   const locale = (localeParam || this.$i18n.locale).toLowerCase()
//   if (
//     playlist &&
//     playlist['official_playlist'] &&
//     playlist['official_playlist_id'] &&
//     playlist['official_playlist'].scenario
//   ) {
//     let combinedTitle = ''
//     playlist['official_playlist'].scenario.forEach(scenario => {
//       const scenarioLangs = scenario.langs
//       let matchedLangObj = scenarioLangs.find(item => item.locale.toLowerCase() === locale)
//       if (!matchedLangObj && locale !== 'en-us') {
//         matchedLangObj = scenarioLangs.find(item => item.locale.toLowerCase() === 'en-us')
//       }
//       if (!matchedLangObj && scenarioLangs.length > 0) {
//         matchedLangObj = scenarioLangs[0]
//       }
//       if (matchedLangObj && matchedLangObj.title) {
//         combinedTitle += matchedLangObj.title
//       }
//     })

//     return combinedTitle || 'COMMON.SCENARIO'
//   }
// }
